import axios from "@/libs/api.request";
// 获取列表
export const getIncome = (params) => {
  return axios.request({
    url: "/extract/agent/income",
    params,
    method: "get",
  });
};

export const addIncome = (data) => {
  return axios.request({
    url: "/extract/agent/income",
    method: "post",
    data,
  });
};

export const updateIncome = (data) => {
  return axios.request({
    url: `/extract/agent/income/${data.id}`,
    method: "put",
    data,
  });
};

export const deleteIncome = (id) => {
  return axios.request({
    url: `/extract/agent/income/${id}`,
    method: "delete",
  });
};

// 获取泡重
export const getIncomeWeight = (params) => {
  return axios.request({
    url: "/extract/charging",
    params,
    method: "get",
  });
};
